import { ArcRotateCamera, Camera, FreeCamera, Ray, Vector3 } from "@babylonjs/core";

import { ManipulationHandler } from "./manipulationHandler";
import { AnimationHandler } from "./AnimationHandler";
import { ViewDetails } from "./view";

export class CameraHandler {

    public CameraList: Camera[] = []
    public ArcCameraList: Camera[] = []
    public ManipulationHandler: ManipulationHandler;
    public Animationhandler: AnimationHandler
    private _details: ViewDetails;
    private _activeCamera: number;

    constructor(details: ViewDetails, animationHandler: AnimationHandler) {
        this._details = details;

        //main camera is always first
        this.CameraList.push(details.scene.activeCamera);

        details.scene.cameras.forEach(element => {
            if ((element.name != "Default View") && (element.name != "RootCamera")) {
                this.CameraList.push(element)
                //element.fov = 0.8;
                //element.minZ = 0.1;                
            }
            //why?
            // else {
            //     if (this.CameraList.length != 1)
            //         details.scene.removeCamera(element);
            // }
        });

        this.Animationhandler = animationHandler;
        this.ManipulationHandler = new ManipulationHandler(
            this.Animationhandler, this._details, this.CameraList[0]
        );
    }
    public FreeToRotateCamera(cameraIndex: number) {
        if (cameraIndex > this.CameraList.length || cameraIndex == 0)
            return;
        
        if (!(this.CameraList[cameraIndex] instanceof FreeCamera))
            return;

        const freeCam = this.CameraList[cameraIndex] as FreeCamera;

        freeCam.update();

        let ray = new Ray(freeCam.globalPosition, freeCam.getDirection(Vector3.Backward()));
        let info = this._details.scene.pickWithRay(ray);
        let target = info.pickedPoint;
        let radius = info.distance;

        if (!info.hit) {
            ray = new Ray(freeCam.globalPosition, freeCam.getDirection(Vector3.Forward()));
            info = this._details.scene.pickWithRay(ray);
            target = info.pickedPoint;
            radius = info.distance;
        }

        if (target == null) {
            const rayNormal = ray.direction.normalize();
            radius = this._details.scene.getWorldExtends().max.subtract(this._details.scene.getWorldExtends().min).length() / 3;
            const direction = rayNormal.scale(radius);
            target = freeCam.position.add(direction);
        }

        const position = freeCam.globalPosition;
        
        const oldCamera = this.CameraList[cameraIndex];
    
        const arc = new ArcRotateCamera(this.CameraList[cameraIndex].name, 0, 0, radius, target, this._details.scene);

        arc.setPosition(position); //calculates alpha beta radius

        arc.wheelPrecision = this._details.camera.wheelPrecision;
        arc.wheelDeltaPercentage = this._details.camera.wheelDeltaPercentage;
        
        arc.fov = freeCam.fov;
        arc.minZ = freeCam.minZ;
        arc.maxZ = freeCam.maxZ;
        
        arc.markAsDirty();
                
        this.CameraList[cameraIndex] = arc;

        if (oldCamera)
            oldCamera.dispose();
    }

    public get ActiveCamera(): number { return this._activeCamera; }
    public set ActiveCamera(value: number) {

        if (value && value < this.CameraList.length) {


            this._activeCamera = value
            
            this._details.scene.activeCamera.detachControl();
            
            if (value < 0)
                 this._details.scene.activeCamera = this._details.camera;
            else
                this._details.scene.activeCamera = this.CameraList[this._activeCamera];

            this._details.scene.activeCamera.attachControl(this._details.view.Canvas, true);

            //this._details.scene.activeCamera.markAsDirty();

            //this._details.scene.activeCamera.update();

            this._details.view.environment.ApplyEnvironment();

            // const bloom = this._details.view.PostProcessingClass.Bloom;
            // const bloomWeight = this._details.view.PostProcessingClass.BloomWeight;
            // const fxaa = this._details.view.PostProcessingClass.Fxaa;
            // const fxaaMulty = this._details.view.PostProcessingClass.FxaaMultyplier;
            // const glow = this._details.view.PostProcessingClass.Glow;
            // const vignette = this._details.view.PostProcessingClass.Vignette;
            // const vignetteWeight = this._details.view.PostProcessingClass.VignetteWeight;
            // const shadows = this._details.view.modelLoader.Shadows;
            // const reflections = this._details.view.modelLoader.Reflections;
            
            // this._details.view.PostProcessingClass.dispose();

            // this._details.view.PostProcessingClass = new PostProcessing(this._details);
            // this._details.view.PostProcessingClass.Bloom = bloom;
            // this._details.view.PostProcessingClass.BloomWeight = bloomWeight;
            // this._details.view.PostProcessingClass.Fxaa = fxaa;
            // this._details.view.PostProcessingClass.FxaaMultyplier = fxaaMulty;
            // this._details.view.PostProcessingClass.Glow = glow;
            // this._details.view.PostProcessingClass.Vignette = vignette;
            // this._details.view.PostProcessingClass.VignetteWeight = vignetteWeight;

            // this._details.view.modelLoader.Shadows = shadows;
            // this._details.view.modelLoader.Reflections = reflections;
    
            this.ManipulationHandler = new ManipulationHandler(
                this.Animationhandler, this._details, this._details.scene.activeCamera
            );
        }
    }
}